import { render, staticRenderFns } from "./file-viewer.vue?vue&type=template&id=6abc8086&scoped=true&"
import script from "./file-viewer.vue?vue&type=script&lang=ts&"
export * from "./file-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./file-viewer.vue?vue&type=style&index=0&id=6abc8086&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc8086",
  null
  
)

export default component.exports